export function init(): void {
    const toggleQuickSearch = () => {
        $('#bcfla-topnav-quicksearch').toggle()
        if ($('#bcfla-topnav-quicksearch').is(':visible')) {
            $('#bcfla-topnav-quicksearch input').focus()
        }
    }

    $('.bcfla-topnav-collapse__quicksearch').click(toggleQuickSearch)
    $('.bcfla-topnav-title__quicksearch').click(toggleQuickSearch)
}
